<template>
  <div>
    <a-card style="margin: 10px 0">
      <div class="filter-section">
        <a-form layout="inline" ref="form" :model="form">
          <a-form-item label="数据类型" name="itemTypeId">
            <a-select
              style="width: 140px"
              v-model:value="form.itemTypeId">
              <a-select-option key="">
                全部
              </a-select-option>
              <a-select-option
                v-for="t in dataTypeList"
                :key="t.id">
                {{ t.chineseInstructions }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item name="id">
            <a-input style="width: 200px" placeholder="请输入上传ID号" v-model:value="form.id" autocomplete="off">
            </a-input>
          </a-form-item>
          <a-form-item label="日期" name="minDate">
              <a-date-picker style="width: 120px"
                valueFormat="YYYY-MM-DD 00:00:00"
                v-model:value="form.minDate"
                :allowClear="false"/>
            </a-form-item>
            <a-form-item label="至" name="maxDate" :labelCol="{span: 4}" :colon="false">
              <a-date-picker style="width: 120px"
                valueFormat="YYYY-MM-DD 23:59:59"
                v-model:value="form.maxDate"
                :allowClear="false"/>
            </a-form-item>
          <a-form-item>
            <a-button @click="resetForm">重置</a-button>
            <a-button type="primary" @click="getData(1)">搜索</a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
    <a-card>
      <div class="table-title">
        <p class="table-name">
          上传列表
        </p>
        <a-button type="primary" @click="openUpload"
          v-if="btnPerm.upload.add.indexOf(currentRole.roleId) !== -1">上传</a-button>
      </div>
      <a-table
        :columns="columns"
        :data-source="tableData"
        rowKey="id"
        :pagination="false">
        <template v-slot:userId="{ text }">
          {{ getUserName(text) }}
        </template>
        <template v-slot:createTime="{ text }">
          <span>{{ getDateTime(text) }}
          </span>
        </template>
        <template v-slot:team="{ text }">
          <span>{{ getTeamName(text) }}
          </span>
        </template>
        <template v-slot:itemTypeId="{ text }">
          <span>{{ getDataTypeName(text) }}</span>
        </template>
        <template v-slot:action="{ record }">
          <span>
            <a @click="openDetail(record)">查看</a>
            <a-divider type="vertical" />
            <a @click="showDeleteConfirm(record)"
              v-if="btnPerm.upload.delete.indexOf(currentRole.roleId) !== -1
              && record.state !== 'finished'">删除</a>
          </span>
        </template>
      </a-table>
      <br>
      <a-pagination
        :current="page.pageNum"
        show-quick-jumper
        :pageSize="10"
        :total="total"
        :show-total="total => `共 ${total} 条`"
        @change="getData"
      ></a-pagination>
    </a-card>
    <UploadDialog ref="uploadDialog"
      :fileList="fileList"
      :allTags="allTags"
      :dataAttrData="dataAttrData"
      @update="getData(1)"></UploadDialog>
    <DetailDialog ref="detailDialog"
      :currentItem="currentItem"
      :allTags="allTags"
      :dataAttrData="dataAttrData"></DetailDialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getTagLabel } from '@/api/tagLabel'
import { getAllAttrCategory, getAttrValue, getAttrSubValue } from '@/api/dataAttr'
import UploadDialog from './UploadDialog'
import DetailDialog from './DetailDialog'
import { getUploadByPage, deleteUpload, getCloudFiles } from '@/api/uploadRecord'
import { getDateTime, getTeamName, getUserName, getDataTypeName } from '@/filters'
// import moment from 'moment'
import config from '@/config'
const columns = [
  {
    title: '上传ID',
    width: '180px',
    dataIndex: 'id'
  },
  {
    title: '名称',
    dataIndex: 'uploadNote'
  },
  {
    title: '文件路径',
    width: '160px',
    dataIndex: 'location'
  },
  {
    title: '上传人',
    dataIndex: 'createUserId',
    slots: { customRender: 'userId' }
  },
  {
    title: '上传时间',
    dataIndex: 'createTime',
    slots: { customRender: 'createTime' }
  },
  {
    title: '团队',
    dataIndex: 'teamId',
    slots: { customRender: 'team' }
  },
  {
    title: '标注类型',
    dataIndex: 'itemTypeId',
    slots: { customRender: 'itemTypeId' }
  },
  {
    title: '处理状态',
    dataIndex: 'state'
  },
  {
    title: '操作',
    slots: { customRender: 'action' }
  }
]

export default {
  components: {
    UploadDialog,
    DetailDialog
  },
  data () {
    return {
      btnPerm: config.btnPerm,
      form: {
        itemTypeId: '',
        minDate: null,
        maxDate: null,
        id: ''
      },
      tableData: [],
      columns,
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      fileList: [],
      currentItem: {},
      dataAttrData: [],
      allTags: []
    }
  },
  computed: {
    ...mapState(['currentRole', 'userInfo', 'dataTypeList'])
  },
  async mounted () {
    this.getAllTags().catch(e => e)
    this.getDataAttr().catch(e => e)
    this.getFileList()
    this.getData(1)
  },
  methods: {
    getDateTime,
    getTeamName,
    getUserName,
    getDataTypeName,
    getAllTags () {
      return getTagLabel().then(res => {
        this.allTags = res.data.map.data.rows
      })
    },
    async getDataAttr () {
      const res = await getAllAttrCategory().catch(e => e)

      this.dataAttrData = res.data.map.data
    },
    
    getFileList () {
      getCloudFiles({
        pageNum: 1, pageSize: 10000
      }).then(res => {
        this.fileList = res.data.map.data.rows
      })
    },
    resetForm () {
      this.$refs.form.resetFields()
    },
    getData (pageNum) {
      if (pageNum) this.page.pageNum = pageNum
      console.log(this.userInfo)
      const createUserId = this.currentRole.roleId === '9' ? this.userInfo.userId : undefined
      getUploadByPage({ ...this.form, ...this.page, createUserId }).then(res => {
        const data = res.data.map.data
        this.total = data.total
        this.tableData = data.rows
      })
    },
    // 上传
    openUpload () {
      this.$refs.uploadDialog.open()
    },
    // 查看
    openDetail (item) {
      this.currentItem = item
      this.$refs.detailDialog.open()
    },
    // 单个删除确认
    showDeleteConfirm (item) {
      this.$confirm({
        title: '删除记录',
        content: '确认删除此条记录？',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk: () => {
          this.handleDelete([item.id])
        },
        onCancel () {
          console.log('cancel')
        }
      })
    },
    // 删除
    async handleDelete (ids) {
      this.loading = true
      for (const id of ids) {
        await deleteUpload(id).catch(e => e)
      }
      this.loading = false
      this.getData(1)
    }
  }
}
</script>
<style>

</style>
